module.exports = __webpack_public_path__ + "static/media/gsap.407caaf4.png";